import ActionCable from 'actioncable';

export const CableConsumer = ActionCable.createConsumer();
